var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"drop":function($event){$event.preventDefault();return (function (e){ return _vm.$emit('drop', e); }).apply(null, arguments)},"dragover":function($event){$event.preventDefault();}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }